{
  "ProjectBuilders": "Tus builders",
  "GroupBuilders": "Builders del grupo",
  "Tracks": "Pistas",
  "BuildersPublished": "Builders publicados",
  "ExpandAll": "Expandir todo",
  "CollapseAll": "Desplegar todo",
  "BuilderPublishedTooltip": "La respuesta a este Builder ha sido publicada en Tu poyecto. La configuración de visibilidad actual es",
  "BuilderPublishedTooltip1": "Puedes cambiarla",
  "BuilderUnPublishedTooltip": "Este Builder no se ha publicado aún. Cualquier Builder no publicado",
  "BuilderUnPublishedTooltip1": " no se incluirá en la página de tu proyecto",
  "Published": "Publicado",
  "Progress": "Progreso",
  "VisibilityOpt1": "Cualquier persona",
  "VisibilityOpt2": "Mi hub, grupos, eventos",
  "VisibilityOpt3": "Mis eventos",
  "VisibilityOpt4": "Solo equipo",
  "PastDue": "vencido",
  "Today": "Hoy",
  "DueToday": "Para hoy",
  "Due": "pagadero",
  "NoDueDate": "Sin fecha de vencimiento",
  "BackToAllBuilders": "Volver a todos los Builders",
  "BuilderNotYetPublished": "Builder aún no publicado",
  "BuilderPublished": "Builder Publicado",
  "ReviewAndPublishTip": "Al menos un tema debe ser respondido antes de que puedas publicar un Builder",
  "TrackCompletion": "Finalización de seguimiento",
  "ViewGroupPage": "Ver página del grupo",
  "BuilderSchedule": "Programa del Builder"
}
